import type { FilterModel } from 'ag-grid-community';

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

export const repairFilterModel = <T extends FilterModel | null | undefined>(
  filterModel: T,
): T => {
  if (!isObject(filterModel)) return filterModel;

  return Object.entries(filterModel).reduce<FilterModel>(
    (acc, [key, value]) => {
      if (!isObject(value) || !value.operator) {
        acc[key] = value;
        return acc;
      }

      const legacyConditions = [value.condition1, value.condition2];
      const source = Array.isArray(value.conditions)
        ? value.conditions
        : legacyConditions;
      const conditions = source
        .map((condition, index) =>
          isObject(condition) ? condition : legacyConditions[index],
        )
        .filter(isObject);

      if (conditions.length > 0) {
        acc[key] = { ...value, conditions };
      }
      return acc;
    },
    {},
  ) as T;
};
